export default function (mimeType) {
  const extensionFromMimeType = new Map([["image/png", ".png"], ["image/bmp", ".bmp"], ["image/gif", ".gif"], ["image/jpeg", ".jpeg"], ["application/pdf", ".pdf"]]);
  return extensionFromMimeType.get(mimeType);
}